// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_DefaultRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface SetupFee_DefaultRow {
currency: string
provider_code: string
amount_cents: number
max_installments: number
id?: number
countries?: string[]
max_installments_by_country?: Record<string, number>
configured_max_installments_by_country?: Record<string, number>
active?: boolean
}

registerContract('SetupFee_DefaultRow', {
  currency:                               { type: 'string',  required: true },
  provider_code:                          { type: 'string',  required: true },
  amount_cents:                           { type: 'number',  required: true },
  max_installments:                       { type: 'number',  required: true },
  id:                                     { type: 'number',  required: false },
  countries:                              { type: 'array',   required: false },
  max_installments_by_country:            { type: 'object',  required: false },
  configured_max_installments_by_country: { type: 'object',  required: false },
  active:                                 { type: 'boolean', required: false },
})
